import { LocalMessage } from '@norges-domstoler/dds-components';
import IContent from '@episerver/spa-core/dist/Models/IContent';
import { useNavigate, useLocation } from 'react-router';
import { useEpiserver } from '@episerver/spa-core';
import './LanguageNotAvailable.scss';
import { General, useTranslation } from 'app/hooks/useTranslations';

type LanguageNotAvailableProps = {
    iContent: IContent;
};

export const LanguageNotAvailable = (props: LanguageNotAvailableProps) => {
    const { t } = useTranslation();
    const ctx = useEpiserver();
    const location = useLocation();
    const navigate = useNavigate();

    function getContextLanguageUrlIfExists() {
        for (let i = 0; i < props.iContent.existingLanguages.length; i++) {
            if (props.iContent.existingLanguages[i].name === ctx.Language) {
                return props.iContent.existingLanguages[i].link;
            }
        }
        return '';
    }

    // if context lang and page lang are the same, then all good
    if (ctx.Language == props.iContent.language.name) {
        return null;
    }

    // If directed to a page with page language not the same as context language, and the page has an existing language branch equal to context lang, change to that lang branch
    if (
        props.iContent.language.name != ctx.Language &&
        location.pathname.length > 3 &&
        ctx.Language != location.pathname.substring(1, 3)
    ) {
        try {
            const newLink = getContextLanguageUrlIfExists();
            if (newLink) {
                const newUrl = new URL(newLink);
                navigate(ctx.getSpaRoute(newUrl.pathname));
                return null;
            }
        } catch (e) {
            console.log('Error when changing language url: ', e);
        }
    }

    // if url language path has same lang as ctx language and an existing lang branch equal to context, then all good
    if (
        location.pathname.length > 3 &&
        ctx.Language == location.pathname.substring(1, 3) &&
        props.iContent.existingLanguages.some((x) => x.name == ctx.Language)
    ) {
        return null;
    }

    return (
        <div className="col-lg-6 language-not-available-message-wrapper">
            <LocalMessage
                htmlProps={{ lang: ctx.Language }}
                className="language-not-available-message"
                message={t(`${General}.PageNotAvailableInThisLangauageWarningMessage`, ctx.Language)}
                purpose="info"
            />
        </div>
    );
};

export default LanguageNotAvailable;
